import React from "react";

import TitledDialog from "./TitledDialog";
import { ResourceName } from "../descriptors";
import CRUDForm, { FormActionButton } from "./CRUDForm";

/// a dialog that present a CRUD form
const CRUDFormDialog: React.FC<{
    open: boolean; /// if the dialog should be shown
    titleId: string; /// the translation id of the dialog title
    hide: () => void; /// hide the dialog - should set the open state to false
    resourceName: ResourceName;
    action: "create" | "update"; /// the action to be performed by the form
    id?: number; /// the id of the resource to be updated when action is update
    extraRequestData?: Record<string, any>; /// extra data to be sent with the request
    extraButtons?: FormActionButton[];
    onSuccess?: () => void; /// do stuff if the form submit is successful - like revalidate the data
}> = ({ open, titleId, hide, resourceName, action, id, extraRequestData, onSuccess, extraButtons }) => {
    const [isFormDirty, setIsFormDirty] = React.useState(false);

    if (!open) return null;

    return (
        <TitledDialog title={titleId} open={open} hide={hide} isContentChanged={() => isFormDirty}>
            <CRUDForm
                resourceName={resourceName}
                action={action}
                id={id}
                onDirtyChange={setIsFormDirty}
                extraRequestData={extraRequestData}
                onSuccess={() => {
                    onSuccess?.();
                    hide();
                }}
                extraButtons={extraButtons}
            />
        </TitledDialog>
    );
};

export default CRUDFormDialog;
